import { Grid, GridItem, Flex } from '@chakra-ui/react'
import React from 'react'
import { Files } from '../../../../Utils'
import { BarFileName, InputComtrol, UploadFile } from '../../../UI'

const GiftcardsProof = ({ formik }) => {
  const deleteVoucher = (fileName) => {
    const { getArrayNamesAndArrayFiles } = Files

    const { resultNames, resultListFiles } = getArrayNamesAndArrayFiles(
      fileName,
      formik.values.stockOfficeName,
      formik.values.stockOffice
    )

    formik.setValues({
      ...formik.values,
      stockOfficeName: resultNames,
      stockOffice: resultListFiles
    })
  }
  const deleteInstructive = (fileName) => {
    const { getArrayNamesAndArrayFiles } = Files

    const { resultNames, resultListFiles } = getArrayNamesAndArrayFiles(
      fileName,
      formik.values.deliveryProofName,
      formik.values.deliveryProof
    )

    formik.setValues({
      ...formik.values,
      deliveryProofName: resultNames,
      deliveryProof: resultListFiles
    })
  }

  const handleChangeVoucher = (e) => {
    if (!e.currentTarget.files) {
      return
    }

    const { getListNamesAndListFiles } = Files

    const { newListNames, newListFiles } = getListNamesAndListFiles(
      e.currentTarget,
      formik.values.stockOfficeName,
      formik.values.stockOffice
    )

    formik.setValues({
      ...formik.values,
      stockOfficeName: newListNames,
      stockOffice: newListFiles
    })
    e.target.value = null
  }

  const handleChangeInstructive = (e) => {
    if (!e.currentTarget.files) {
      return
    }

    const { getListNamesAndListFiles } = Files

    const { newListNames, newListFiles } = getListNamesAndListFiles(
      e.currentTarget,
      formik.values.deliveryProofName,
      formik.values.deliveryProof
    )

    formik.setValues({
      ...formik.values,
      deliveryProofName: newListNames,
      deliveryProof: newListFiles
    })
    e.target.value = null
  }

  return (
    <Grid
      templateColumns={{
        lg: 'repeat(2, 1fr)',
        md: 'repeat(1, 1fr)',
        sm: 'repeat(1, 1fr)'
      }}
      gap={2}
    >
      <GridItem>
        <InputComtrol label={'Oficio inventario'}>
          <UploadFile
            id={'stockOfficeName'}
            direction={'row'}
            sizeIcon={30}
            p={5}
            onChange={(e) => handleChangeVoucher(e)}
            error={Boolean(formik.errors.stockOfficeName)}
            errorText={formik.errors.stockOfficeName}
          />
        </InputComtrol>
        <Flex direction={'column'} gap={1}>
          {formik.values.stockOfficeName.map((item) => (
            <BarFileName
              key={item?.name}
              fileName={item?.name}
              fileUrl={item?.url}
              onDelete={() => deleteVoucher(item?.name)}
            />
          ))}
        </Flex>
      </GridItem>
      <GridItem>
        <InputComtrol label={'Cuadro demostrativo de entrega'}>
          <UploadFile
            id={'deliveryProofName'}
            direction={'row'}
            sizeIcon={30}
            p={5}
            onChange={(e) => handleChangeInstructive(e)}
            error={Boolean(formik.errors.deliveryProofName)}
            errorText={formik.errors.deliveryProofName}
          />
        </InputComtrol>
        <Flex direction={'column'} gap={1}>
          {formik.values.deliveryProofName.map((item) => (
            <BarFileName
              key={item?.name}
              fileName={item?.name}
              fileUrl={item?.url}
              onDelete={() => deleteInstructive(item?.name)}
            />
          ))}
        </Flex>
      </GridItem>
    </Grid>
  )
}

export default GiftcardsProof
